import { css } from '@bts-web/utils-style-engine';
import {
  intlFiatValueFormatting,
  MaximumFractionDigits,
} from '@bts-web/utils-formatting';

const containerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'small',
  width: '100%',
});

const subItemsStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'extra_small_2',
});

const rowStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 'extra_small',
});

const subLabelStyles = css({
  color: 'neutrals.text_secondary',
  fontSize: 'caption.small',
  fontWeight: 'caption.small',
  lineHeight: 'caption.small',
  letterSpacing: 'caption.small',
});

const subValueStyles = css({
  color: 'neutrals.text_secondary',
  fontSize: 'caption.small',
  fontWeight: 'caption.small',
  lineHeight: 'caption.small',
  letterSpacing: 'caption.small',
});

const totalStyles = css({
  color: 'neutrals.text_primary',
  fontSize: 'title.medium_medium',
  fontWeight: 'title.medium_medium',
  lineHeight: 'title.medium_medium',
  letterSpacing: 'title.medium_medium',
});

interface LineItem {
  label: string;
  value: number;
}

interface FeesForAmountProps {
  lineItems?: LineItem[];
  totalLabel: string;
  total: number;
  currency: string;
  locale: string;
  className?: string;
  dataTestId?: string;
}

export const FeesForAmount = ({
  lineItems,
  totalLabel,
  total,
  currency,
  locale,
  className,
  dataTestId = 'fees-for-amount',
}: FeesForAmountProps) => {
  const format = (value: number) =>
    intlFiatValueFormatting(value, {
      locale,
      currency,
      fractionDigits: MaximumFractionDigits.FIAT,
    });

  return (
    <div
      data-testid={dataTestId}
      className={`${containerStyles} ${className ?? ''}`}
    >
      {lineItems && lineItems.length > 0 && (
        <div className={subItemsStyles}>
          {lineItems.map(({ label, value }) => (
            <div key={label} className={rowStyles}>
              <span className={subLabelStyles}>{label}</span>
              <span className={subValueStyles}>{format(value)}</span>
            </div>
          ))}
        </div>
      )}

      <div className={rowStyles}>
        <span className={totalStyles}>{totalLabel}</span>
        <span className={totalStyles}>{format(total)}</span>
      </div>
    </div>
  );
};
